import React, { useState, useEffect } from "react"
import { useQuery } from "react-query"
import { FastField, useFormikContext } from "formik"

import IntlTelInput from "react-intl-tel-input"
import "react-intl-tel-input/dist/main.css"

import "react-datepicker/dist/react-datepicker.css"

import FormError from "../../../formError"

const Presenter = () => {
  const {
    values,
    errors,
    touched,
    handleChange,
    setFieldValue,
  } = useFormikContext()

  const [identityTypes, setIdentityTypes] = useState([])
  const [loading, setLoading] = useState(false)

  const {
    isLoading,
    error,
    data: countries,
    isFetching,
  } = useQuery("countries", () =>
    fetch(`${process.env.DIY_BASE_URL}/api/options/v1/Countries`).then((res) =>
      res.json()
    )
  )

  const {
    isLoading: statesLoading,
    error: stateError,
    data: st,
    isFetching: isFetchingStates,
  } = useQuery("st", () =>
    fetch(`${process.env.GATSBY_SPARKLE_LOCAL_BASE_URL}/api/v1/kyc/states`).then((res) =>
      res.json()
    )
  )

  const uploadImage = (file_data, file_location) => {
    setLoading(true)
    const data = new FormData()
    data.append("file", file_data)

    fetch(`${process.env.DIY_BASE_URL}/api/options/v1/FileUpload`, {
      method: "post",
      body: data,
    })
      .then((resp) => resp.json())
      .then((data) => {
        setFieldValue(file_location, data.resp)
        setFieldValue(`${file_location}_name`, file_data.name)
        setLoading(false)
      })
      .catch((err) => console.log(err))
  }

  const setFile = (file, location) => {
    uploadImage(file, location)
  }

  return (
    <>
      <div className="form-row justify-between">
        <div className="form-group col-md-5">
          <label htmlFor="company_secretary">Company Secretary</label>

          <FastField
            className="form-control custom-select mb-4"
            as="select"
            id="company_secretary"
            name="company_secretary"
          >
            <option value="">Select</option>

            <option value="Yes">Yes</option>
            <option value="No">No</option>
          </FastField>

          <FormError
            touched={touched.company_secretary}
            message={errors.company_secretary}
          />
        </div>
      </div>

      {values.company_secretary === "Yes" && (
        <div>
          <div className="form-row justify-between">
            <div className="form-group col-md-5">
              <label htmlFor="secretary_type">Secretary type</label>

              <FastField
                className="form-control custom-select mb-4"
                as="select"
                id="secretary_type"
                name="secretary_type"
              >
                <option value="">Select</option>

                <option value="Individual">Individual</option>
                <option value="No">Corporate Organization</option>
              </FastField>

              <FormError
                touched={touched.secretary_type}
                message={errors.secretary_type}
              />
            </div>
          </div>

          <div className="form-row justify-between">
            <div className="form-group col-md-5">
              <label htmlFor="secretary_firstname"> First Name</label>
              <FastField
                type="text"
                className="form-control"
                id="secretary_firstname"
                name="secretary_firstname"
                autoComplete="given-name"
              />

              <FormError
                touched={touched.secretary_firstname}
                message={errors.secretary_firstname}
              />
            </div>

            <div className="form-group col-md-5">
              <label htmlFor="secretary_surname"> Last Name</label>
              <FastField
                type="text"
                className="form-control"
                id="secretary_surname"
                name="secretary_surname"
                autoComplete="family-name"
              />

              <FormError
                touched={touched.secretary_surname}
                message={errors.secretary_surname}
              />
            </div>
          </div>

          <div className="form-row justify-between">
            <div className="form-group col-md-5">
              <label htmlFor="secretary_email">Email Address</label>
              <input
                type="text"
                className="form-control"
                id="secretary_email"
                name="secretary_email"
                onChange={handleChange}
                value={values.secretary_email}
              />

              <FormError
                touched={touched.secretary_email}
                message={errors.secretary_email}
              />
            </div>

            <div className="form-group col-md-5">
              <label htmlFor="secretary_phone">Phone Number</label>

              <IntlTelInput
                inputClassName="form-control"
                defaultCountry="ng"
                id="secretary_phone"
                fieldName="secretary_phone"
                autoComplete="tel"
                onPhoneNumberChange={(fullnumber, newNumber) => {
                  setFieldValue("secretary_phone", newNumber)
                }}
                value={values.secretary_phone}
                placeholder="XXXX XXXX XXX"
              />

              <FormError
                touched={touched.secretary_phone}
                message={errors.secretary_phone}
              />
            </div>
          </div>

          <div className="form-row justify-between">
            <div className="form-group col-md-5">
              <label htmlFor="secretary_country">Company Country</label>
              <FastField
                className="form-control custom-select"
                as="select"
                id="secretary_country"
                name="secretary_country"
                required
              >
                <option value="">Country</option>
                {countries?.map((country) => (
                  <option key={country.value} value={country.value}>
                    {country.display}
                  </option>
                ))}
              </FastField>

              <FormError
                touched={touched.secretary_country}
                message={errors.secretary_country}
              />
            </div>
          </div>

          <div className="form-row justify-between">
            <div className="form-group col-md-5">
              <label htmlFor="secretary_state">State</label>
              <FastField
                className="form-control custom-select"
                as="select"
                id="secretary_state"
                name="secretary_state"
                required
              >
                <option value="" label="Select State">
                  Select State
                </option>
                {st?.data.map((data) => (
                  <option key={data.id} value={data.name}>
                    {data.name}
                  </option>
                ))}
              </FastField>

              <FormError
                touched={touched.secretary_state}
                message={errors.secretary_state}
              />
            </div>

            <div className="form-group col-md-5">
              <label htmlFor="secretary_city">City</label>
              <FastField
                type="text"
                className="form-control"
                id="secretary_city"
                name="secretary_city"
                required
              />

              <FormError
                touched={touched.secretary_city}
                message={errors.secretary_city}
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group col-md-12">
              <label htmlFor="secretary_address">Address</label>
              <FastField
                as="textarea"
                rows="3"
                className="form-control"
                id="secretary_address"
                name="secretary_address"
                required
              />

              <FormError
                touched={touched.secretary_address}
                message={errors.secretary_address}
              />
            </div>
          </div>

          {/* representative section starts here */}

          <div className="form-row justify-between">
            <div className="form-group col-md-5">
              <label htmlFor="identity_type">Identity Type</label>
              <FastField
                className="form-control custom-select"
                as="select"
                id="identity_type"
                name="identity_type"
                required
              >
                <option value="">------</option>
                <option value="Driver's Licence">Driver's Licence</option>
                <option value="National ID Card">National ID Card</option>
                <option value="International Passport">
                  International Passport
                </option>
                <option value="Voters Card">Voters Card</option>
              </FastField>

              <FormError
                touched={touched.identity_type}
                message={errors.identity_type}
              />
            </div>

            <div className="form-group col-md-5">
              <label htmlFor="identity_number">Identity Number</label>
              <FastField
                type="text"
                className="form-control"
                id="identity_number"
                name="identity_number"
                required
              />

              <FormError
                touched={touched.identity_number}
                message={errors.identity_number}
              />
            </div>
          </div>

          <div
            className={
              loading
                ? "progress_state form-row justify-content-center"
                : "form-row justify-content-center"
            }
          >
            <div className="form-group col-md-12">
              <label htmlFor="identity">Identity</label>
              <input
                type="file"
                className="form-control border-0"
                id="identity"
                name="identity"
                onChange={(e) => setFile(e.target.files[0], "identity")}
              />

              <label
                htmlFor="identity"
                className="font-weight-light text-muted"
              >
                jpg,png,pdf file only
              </label>

              <FormError touched={touched.identity} message={errors.identity} />
            </div>

            <p>{loading && "Uploading"}</p>
          </div>
        </div>
      )}
    </>
  )
}

export default Presenter
